import { useEffect, useState } from "react";
import { useThemeStore, useUserStore } from "@/store";
import Header from "../organisms/Header";
import Sidebar from "../organisms/Sidebar";
import useQuery from "@/hooks/useQuery";
import { Theme, ThemeProps } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import User from "@/types/User";
import useLogStoreWithSync from "@/store/logStore";
import useTabManager from "@/hooks/useTabManager";

const ThemeConfiguration = {
  accentColor: "yellow" as ThemeProps["accentColor"],
};

interface LayoutProps {
  children: React.ReactNode;
  activeNotice: any;
}

const Layout = ({ children, activeNotice }: LayoutProps) => {
  const [showNotice, setShowNotice] = useState(!!activeNotice);
  const theme = useThemeStore((state) => state.theme);
  const setCurrentUser = useUserStore((state) => state.setCurrentUser);
  const setPermissions = useUserStore((state) => state.setPermissions);
  
  const { data, isLoading } = useQuery("/get_current_user");
  const tabId = useTabManager();
  
  useLogStoreWithSync();


  useEffect(() => {
    if (data) {
      const userData = data as User;
      setCurrentUser(userData);

      const allPermissions = [
        ...(userData.direct_permissions || []),
        ...(userData.roles.map((role) => role.permissions).flat() || [])
      ];

      const uniquePermissions = Array.from(
        new Set(allPermissions.map((permission) => JSON.stringify(permission)))
      ).map((permission) => JSON.parse(permission));

      setPermissions(uniquePermissions);
    }
  }, [data, isLoading]);

  useEffect(() => {
    if (theme === "dark") document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  }, [theme]);

  return (
    <Theme {...ThemeConfiguration} appearance={theme}>
      <div className="flex">
        <Sidebar />
        <div className="w-full overflow-auto pl-14 lg:pl-0">
          <Header loading={isLoading} />
          <div className="page-body">
          {showNotice && (
              <div
              className="notice-banner p-4 mb-4 mt-2 rounded-md border border-gray-500 bg-gray-100 w-2/4 text-black-700 font-semibold text-center shadow-md relative mx-auto"
            >
              <button
                className="absolute top-2 right-2 text-black-700 font-bold"
                onClick={() => setShowNotice(false)}
              >
                X
              </button>
              {activeNotice.notice_message}
            </div>
            )}
            {children}
          </div>
        </div>
      </div>
    </Theme>
  );
};

export default Layout;
